import { createContext } from 'react';
import { FsContextValue } from '../type';
import { fsDataInitialState } from './fsReducer/fsReducer';

export const initialValue: FsContextValue = {
  fsDataState: fsDataInitialState,
  dispatch: () => {},
};

export const FsContext = createContext(initialValue);
